/**
 * @fileoverview useCalendar hook
 *
 * Separated from the provider so React Refresh stays happy
 * (the `react-refresh/only-export-components` rule fires when a
 * non-component is exported next to components).
 */

import { useContext } from "react";

import {
  CalendarContext,
  type ICalendarContext,
} from "./calendar-react-context";

export function useCalendar(): ICalendarContext {
  const context = useContext(CalendarContext);
  if (!context) {
    throw new Error("useCalendar must be used within a CalendarProvider.");
  }
  return context;
}
